import { Caption, TextLink } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import router from 'next/router'
import React from 'react'

import Icon from '@/design-lib/components/Icons'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { suggestedOnboardingPath } from '@/i18n-routes'
import { baseRadius } from '@/shared-styles/common-variables'
import { backgroundColor, flexCenter } from '@/shared-styles/styles.css'
import { buildRelativeLocalizedLink } from '@/utils/navigation'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick } from '@/utils/tracking/eventsHandlers'

const InferredCriteriaBanner: React.FC = () => {
  const { lang, t } = useTranslation()
  return (
    <div
      className={cn(
        backgroundColor.orange100,
        sprinkles({ borderRadius: baseRadius, flexDirection: 'column', marginBottom: 'xl', padding: 'm' })
      )}
      style={{ display: 'inline-flex' }}
    >
      <div className={cn(flexCenter, sprinkles({ gap: 's-m', marginBottom: 's' }))}>
        <Icon.MagicIcon />
        <Caption>{t('suggested:Suggested_SetPreferenceBanner_Description')}</Caption>
      </div>
      <div className={sprinkles({ alignSelf: 'flex-end', cursor: 'pointer' })}>
        <TextLink
          withIcon
          label={t('suggested:Suggested_SetPreferenceBanner_CTA')}
          sizeVariant="small"
          onClick={() => {
            router.push(buildRelativeLocalizedLink(suggestedOnboardingPath, lang))
            handleClick(GTMEventCategory.SuggestedPage, 'UpdateInferredPreferences')
          }}
        />
      </div>
    </div>
  )
}

export default InferredCriteriaBanner
